import { useState } from "react";
import { Modal } from "../../../../../../shared/Modal/Modal";
import { ChangeEnvModal } from "../../../../../../processes/modals/ChangeEnvModal/ChangeEnvModal";
import styles from "./EnvironmentListItem.module.scss";
import clsx from "clsx";
import { useAppDispatch, useAppSelector } from "../../../../../../redux/store";
import {
  getActiveEnvironmentId,
  getEnvironments,
} from "../../../../../../redux/reducers/ui/uiSelectors";
import { createPortal } from "react-dom";
import { changeShowModal } from "../../../../../../redux/reducers/app/appReducer";
import {
  setActiveEnvironmentId,
  setCurrentEnvironment,
} from "../../../../../../redux/reducers/ui/uiReducer";
import placeHolderImage from "../../../../../../assets/images/item_placeholder.png";
import { useURLRouting } from "../../../../../../utils/hooks/useURLRouting";

export const EnvironmentListItem = ({ item }: any) => {
  const { id, image, name } = item;
  const dispatch = useAppDispatch();
  const [isOpen, setIsOpen] = useState(false);
  const activeEnvironmentId = useAppSelector(getActiveEnvironmentId());
  const environments = useAppSelector(getEnvironments());
  const { setItem } = useURLRouting();

  const handleNavigateToEvnItem = async (id: number) => {
    dispatch(changeShowModal({ nameModal: "loader", stateModal: true }));
    setItem(String(id));

    if (activeEnvironmentId !== id) {
      const activeEnv = environments?.find((stage: any) => stage.id === id);
      if (activeEnv) {
        dispatch(setActiveEnvironmentId(id));
        dispatch(setCurrentEnvironment(activeEnv));
      }
    }

    dispatch(changeShowModal({ nameModal: "loader", stateModal: false }));
  };

  const handleOpenConfirmPopup = (id: number) => {
    if (activeEnvironmentId !== id) {
      setIsOpen(true);
    } else {
      handleNavigateToEvnItem(id);
    }
  };

  const handleCloseModal = () => {
    setIsOpen(false);
  };

  return (
    <>
      <div
        key={id}
        tabIndex={0}
        className={clsx({
          [styles.item]: true,
          [styles.active]: id === activeEnvironmentId,
        })}
        onClick={() => handleOpenConfirmPopup(id)}
        onKeyUp={(e: any) => {
          if (e.code === "Enter") {
            handleNavigateToEvnItem(id);
          }
        }}
      >
        <div className={styles.img_wrapper}>
          {image ? (
            <img src={image} alt="environment" />
          ) : (
            <img src={placeHolderImage} alt="placeHolderImage" />
          )}
        </div>
        <div className={styles.name}>{name}</div>
      </div>

      {isOpen &&
        createPortal(
          <Modal header="Please note" onClose={handleCloseModal}>
            <ChangeEnvModal
              handleClose={handleCloseModal}
              handleConfirm={() => handleNavigateToEvnItem(id)}
            />
          </Modal>,
          document.body
        )}
    </>
  );
};
